$(document).ready(function () {
  $(".commmunity-slider").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    autoplay: true,
    // speed: 1000,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: "7%",
    infinite: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 2100,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          swipeToSlide: true,
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          swipeToSlide: true,
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide: true,
          centerPadding: "40%",
        },
      },
    ],
  });
});
